import Typography from '@mui/material/Typography';
import { motion } from 'framer-motion';
import IconButton from '@mui/material/IconButton';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { lighten } from '@mui/material/styles';
import { Box } from '@mui/system';
import Button from '@mui/material/Button';
import { useContext } from 'react';
import { DeleteFileFolderContext, FileFolderContext } from './HrPolicies';
import { useEffect } from 'react';
import moment from 'moment';
import OAuthService from 'src/app/auth/services/oAuthService';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import { useState } from 'react';
import DialogBox from '../utilities/DialogBox';
import jwtDecode from 'jwt-decode';

function DetailSidebarContent(props) {
  const [selectedItem, setSelectedItem] = useContext(FileFolderContext);
  const [deletedMsg, setDeletedMsg] = useContext(DeleteFileFolderContext);
  const [dialogOpen, setDialogOpen] = useState(false);
  const policyUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.policyLibrary}`
  const libraryUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.libraryStructure}`
  const downloadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileDownload}`;
  const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));

  if (!selectedItem) {
    return null;
  }

  const handleDelete = async (event) => {
    try {
      if (selectedItem?.type === 'file') {
        const deletefile = await OAuthService.deleteData(policyUrl + `/deletePolicy`, selectedItem?.id);
        if (deletefile) {
          setSelectedItem('')
          setDeletedMsg("File deleted successfully")
        }
      } else {
        const deletefolder = await OAuthService.deleteData(libraryUrl + `/deleteLibrary`, selectedItem?.id);
        if (deletefolder) {
          setDeletedMsg("Folder deleted successfully")
          setSelectedItem('')
        }
      }
      setDialogOpen(false)
    } catch (error) {

    }
  }

  const handleClose = () => {
    setDialogOpen(false)
  }

  const handleDownload = async () => {
    const download = await OAuthService.getDownload(downloadUrl + `/${selectedItem?.fileName}`);
    const blob = download?.data
    if (blob) {
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = selectedItem?.fileName;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  }

  return (
    <motion.div
      initial={{ y: 50, opacity: 0.8 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.3 } }}
      className="file-details p-24 sm:p-32"
    >
      <div className="flex items-center justify-end w-full">
        <IconButton className="" size="large"
        onClick={() => setSelectedItem('')}
        >
          <FuseSvgIcon>heroicons-outline:x</FuseSvgIcon>
        </IconButton>
      </div>

      <Box
        className=" w-full rounded-8 border preview h-128 sm:h-256 file-icon flex items-center justify-center my-32"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === 'light'
              ? lighten(theme.palette.background.default, 0.4)
              : lighten(theme.palette.background.default, 0.02),
        }}
      >
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1, transition: { delay: 0.3 } }}>
          <div className="flex flex-auto w-full items-center justify-center">
            {(selectedItem?.type && selectedItem?.type === 'file') ? <FuseSvgIcon className="" size={56} color="disabled">
              heroicons-outline:document
            </FuseSvgIcon> :
              <FuseSvgIcon className="" size={56} color="disabled">
                heroicons-outline:folder
              </FuseSvgIcon>}
          </div>
        </motion.div>
      </Box>

      <Typography className="text-18 font-medium">{selectedItem?.fileName || selectedItem?.name}</Typography>

      <div className="text-16 font-medium mt-32">Information</div>
      <div className="flex flex-col mt-16 border-t border-b divide-y font-medium">
        <div className="flex items-center justify-between py-12">
          <Typography color="text.secondary">Created By</Typography>
          <Typography>{selectedItem?.createdBy}</Typography>
        </div>
        <div className="flex items-center justify-between py-12">
          <Typography color="text.secondary">Created At</Typography>
          <Typography>{selectedItem?.createdAt && moment(selectedItem?.createdAt).format('YYYY-MM-DD')}</Typography>
        </div>
        <div className="flex items-center justify-between py-12">
          <Typography color="text.secondary">Modified At</Typography>
          <Typography>{selectedItem?.updatedAt && moment(selectedItem?.updatedAt).format('YYYY-MM-DD')}</Typography>
        </div>
        <div className="flex items-center justify-between py-12">
          <Typography color="text.secondary">Modified By</Typography>
          <Typography>{selectedItem?.updatedBy}</Typography>
        </div>
        {(selectedItem?.type && selectedItem?.type === 'file') && <div className="flex items-center justify-between py-12">
          <Typography color="text.secondary">Size</Typography>
          <Typography>{selectedItem?.fileSize}</Typography>
        </div>}
      </div>



      <div className="flex flex-row mt-32">
        {(selectedItem?.type && selectedItem?.type === 'file') && <Button className="grow"
          color="warning" variant="contained" onClick={handleDownload}>
          <FuseSvgIcon>
                heroicons-outline:document-download
              </FuseSvgIcon>Download
        </Button>}
        {(token?.scope.includes('ROLE_HR') || token?.scope.includes('ROLE_MD')) && <Button className="grow ml-5"
          color="warning" variant="contained" onClick={() => setDialogOpen(true)}>
         <FuseSvgIcon>
                heroicons-outline:trash
              </FuseSvgIcon> Delete
        </Button>}
      </div>

      <DialogBox
        open={dialogOpen}
        handleClose={handleClose}
        handleSumbit={handleDelete}
        title={"delete " + selectedItem?.type}
      />
    </motion.div>
  );
}

export default DetailSidebarContent;
